import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fortuneronrentinpune() {



  const cardData = {


  keyword: "Fortuner On Rent in Pune",

  headingDescription: "Trustline Cab provides premium Toyota Fortuner on rent in Pune for luxury travel, corporate meetings, airport transfers, VIP transportation, family trips, weddings, business events, and outstation journeys. Toyota Fortuner is a perfect choice for passengers looking for a powerful SUV with premium comfort, spacious interiors, strong road presence, and a smooth long-distance driving experience. Whether you need Fortuner rental for Pune local travel, Mumbai airport transfer, corporate events, one-day rental, outstation tours, or special occasions, our professional chauffeurs ensure a safe and luxurious journey. With well-maintained premium SUVs, experienced drivers, transparent pricing, doorstep pickup, easy online booking, flexible rental packages, and 24/7 customer support, Trustline Travels is your trusted choice for Fortuner rental services in Pune.",

  topPlaces: [
    {
      title: "Lonavala",
      description: "Lonavala is a popular hill station between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and scenic landscapes. Fortuner is an excellent choice for comfortable family and luxury weekend trips."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a premium hill station near Pune known for strawberry farms, viewpoints, lakes, waterfalls, and pleasant weather. Fortuner rental provides a comfortable SUV experience for holiday travel."
    },
    {
      title: "Goa",
      description: "Goa is a famous luxury holiday destination known for beaches, resorts, nightlife, churches, and adventure activities. Fortuner rental is suitable for premium long-distance travel from Pune to Goa."
    },
     {
      title: "Mumbai Airport",
      description: "Mumbai Airport is a major destination for VIP guests, corporate executives, and luxury travelers arriving from different cities. Fortuner rental provides a premium and comfortable airport transfer experience from Pune."
    },
    {
      title: "Bandra",
      description: "Bandra is one of Mumbai's most premium areas, known for luxury hotels, corporate offices, celebrity residences, restaurants, and entertainment destinations. Fortuner is a preferred choice for luxury travel to this location."
    },
    {
      title: "BKC Mumbai",
      description: "Bandra Kurla Complex is Mumbai's leading corporate district featuring multinational companies, financial institutions, convention centers, and premium business facilities. Fortuner rental is ideal for executive travel."
    },
    {
      title: "Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's biggest technology hub, home to multinational companies, software firms, and corporate campuses. Premium SUVs like Fortuner are preferred for executive transportation."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport serves business travelers, tourists, and VIP passengers requiring comfortable transportation. Fortuner rental offers a luxury airport pickup and drop experience with professional chauffeurs."
    },
    {
      title: "Chakan MIDC",
      description: "Chakan MIDC is a major industrial destination housing automobile companies, manufacturing units, and corporate facilities. Fortuner rental is suitable for business visits and industrial travel."
    },
   
    {
      title: "Alibaug",
      description: "Alibaug is a coastal destination near Mumbai known for beaches, forts, resorts, and peaceful getaways. It is a popular choice for luxury weekend trips and family vacations from Pune."
    }
  ],





"services": [
  {
    "name": "Fortuner on Rent Pune",
    "description": "Book Fortuner on Rent Pune for luxury travel, corporate meetings, weddings, airport transfers, and outstation trips with premium comfort, experienced chauffeurs, and well-maintained Toyota Fortuner vehicles."
  },
  {
    "name": "Fortuner Rent in Pune",
    "description": "Choose Fortuner Rent in Pune for premium SUV rental services with flexible packages, professional drivers, luxury interiors, and reliable transportation for every occasion."
  },
  {
    "name": "Toyota Fortuner on Rent in Pune",
    "description": "Hire Toyota Fortuner on Rent in Pune for business travel, family trips, events, and long-distance journeys with spacious seating, powerful performance, and chauffeur-driven service."
  },
  {
    "name": "Toyota Fortuner Rental in Pune",
    "description": "Book Toyota Fortuner Rental in Pune with affordable rental plans, luxury features, experienced drivers, and comfortable travel solutions for local and outstation requirements."
  },
  {
    "name": "Toyota Fortuner Rental in Pune Airport",
    "description": "Reserve Toyota Fortuner Rental in Pune Airport for premium airport pickup and drop services with punctual drivers, luxury comfort, and smooth transportation."
  },
  {
    "name": "Toyota Fortuner Rental in Pune Airport Contact Number",
    "description": "Contact Toyota Fortuner Rental in Pune Airport for instant booking, professional chauffeur service, transparent pricing, and 24x7 customer assistance."
  },
  {
    "name": "Toyota Fortuner Hire for Corporate Events",
    "description": "Book Toyota Fortuner Hire for Corporate Events with premium SUV comfort, professional drivers, executive travel facilities, and reliable corporate transportation."
  },
  {
    "name": "Toyota Fortuner Hire for Corporate Events Near Me",
    "description": "Find Toyota Fortuner Hire for Corporate Events Near Me with luxury vehicles, flexible rental options, experienced chauffeurs, and convenient pickup services."
  },
  {
    "name": "Toyota Fortuner Hire for Wedding Function",
    "description": "Hire Toyota Fortuner for Wedding Function with stylish SUV travel, premium comfort, professional drivers, and reliable transportation for special occasions."
  },
  {
    "name": "Fortuner on Rent for Wedding",
    "description": "Book Fortuner on Rent for Wedding events with luxury interiors, elegant appearance, chauffeur service, and comfortable travel for guests and families."
  },
  {
    "name": "Fortuner Rent for One Day",
    "description": "Rent Fortuner for One Day in Pune with affordable pricing, premium SUV facilities, professional drivers, and flexible rental packages."
  },
  {
    "name": "Fortuner Hire in Pimpri Chinchwad",
    "description": "Book Fortuner Hire in Pimpri Chinchwad for corporate travel, family trips, airport transfers, and outstation journeys with luxury comfort."
  },
  {
    "name": "Fortuner on Rent for Outstation",
    "description": "Choose Fortuner on Rent for Outstation travel with spacious seating, premium features, experienced chauffeurs, and safe highway journeys."
  },
  {
    "name": "Fortuner Hire for Corporate Office",
    "description": "Hire Fortuner for Corporate Office transportation with executive comfort, punctual service, professional drivers, and reliable business travel solutions."
  },
  {
    "name": "Fortuner on Rent in Pune Monthly",
    "description": "Book Fortuner on Rent in Pune Monthly with flexible long-term rental plans, chauffeur options, luxury comfort, and affordable packages."
  },
  {
    "name": "Fortuner Rent Per Km",
    "description": "Check Fortuner Rent Per Km rates with transparent pricing, flexible packages, and premium SUV rental options for local and outstation travel."
  },
  {
    "name": "Fortuner on Rent in Mumbai",
    "description": "Hire Fortuner on Rent in Mumbai for luxury transportation, corporate events, weddings, airport transfers, and outstation journeys."
  },
  {
    "name": "Fortuner on Rent Mumbai",
    "description": "Book Fortuner on Rent Mumbai with premium SUV vehicles, professional chauffeurs, comfortable seating, and reliable rental services."
  },
  {
    "name": "Fortuner Car on Rent in Mumbai",
    "description": "Choose Fortuner Car on Rent in Mumbai for business travel, family trips, events, and premium chauffeur-driven transportation."
  },
  {
    "name": "Fortuner Rent in Mumbai",
    "description": "Reserve Fortuner Rent in Mumbai with luxury interiors, experienced drivers, flexible booking options, and affordable rental plans."
  },
  {
    "name": "Toyota Fortuner on Rent in Velocity Cabs",
    "description": "Book Toyota Fortuner on Rent in Velocity Cabs for premium SUV travel with professional chauffeurs, luxury comfort, and reliable service."
  },
  {
    "name": "Fortuner on Rent in Pune",
    "description": "Hire Fortuner on Rent in Pune for luxury airport transfers, corporate travel, weddings, and outstation trips with premium facilities."
  },
  {
    "name": "Toyota Fortuner Rental Pune",
    "description": "Book Toyota Fortuner Rental Pune for comfortable SUV travel with professional drivers, affordable packages, and premium customer service."
  },
  {
    "name": "Fortuner Cab in Pune",
    "description": "Choose Fortuner Cab in Pune for luxury transportation with spacious seating, AC comfort, experienced chauffeurs, and reliable travel solutions."
  },
  {
    "name": "Fortuner Car Hire Pune",
    "description": "Hire Fortuner Car Pune for business trips, family vacations, events, and outstation journeys with premium SUV facilities."
  },
  {
    "name": "Fortuner Taxi Service Pune",
    "description": "Book Fortuner Taxi Service Pune for airport transfers, corporate travel, local rides, and long-distance journeys with professional drivers."
  },
  {
    "name": "Book Fortuner Cab Pune",
    "description": "Book Fortuner Cab Pune online with easy reservations, flexible rental plans, luxury vehicles, and experienced chauffeur service."
  },
  {
    "name": "Fortuner Car Rental Pune",
    "description": "Choose Fortuner Car Rental Pune for premium SUV rentals with comfortable interiors, reliable service, and affordable pricing."
  },
  {
    "name": "Fortuner SUV Rental Pune",
    "description": "Hire Fortuner SUV Rental Pune for luxury travel, corporate transportation, events, and outstation trips with premium comfort."
  },
  {
    "name": "Luxury Fortuner on Rent Pune",
    "description": "Book Luxury Fortuner on Rent Pune for executive travel, weddings, business meetings, and premium journeys with chauffeur-driven service."
  },
  {
    "name": "Cheap Fortuner on Rent Pune",
    "description": "Choose Cheap Fortuner on Rent Pune with affordable rental packages, luxury SUV comfort, and professional driver support."
  },
  {
    "name": "Fortuner Cab Service Pune",
    "description": "Reserve Fortuner Cab Service Pune for reliable transportation with premium SUVs, experienced chauffeurs, and flexible travel options."
  },
  {
    "name": "Fortuner Outstation Cab Pune",
    "description": "Book Fortuner Outstation Cab Pune for comfortable long-distance travel with luxury seating, professional drivers, and safe highway journeys."
  },
  {
    "name": "Fortuner Airport Pickup Pune",
    "description": "Choose Fortuner Airport Pickup Pune for premium airport transfers with timely service, luggage assistance, and chauffeur-driven comfort."
  },
  {
    "name": "Fortuner Cab Pune to Mumbai",
    "description": "Book Fortuner Cab Pune to Mumbai for luxury intercity travel with spacious seating, experienced drivers, and comfortable highway journeys."
  }
],

"tableData": [
  ["Fortuner on Rent Pune", "Fortuner Rent in Pune"],
  ["Toyota Fortuner on Rent in Pune", "Toyota Fortuner Rental in Pune"],
  ["Toyota Fortuner Rental in Pune Airport", "Toyota Fortuner Rental in Pune Airport Contact Number"],
  ["Toyota Fortuner Hire for Corporate Events", "Toyota Fortuner Hire for Corporate Events Near Me"],
  ["Toyota Fortuner Hire for Wedding Function", "Fortuner on Rent for Wedding"],
  ["Fortuner Rent for One Day", "Fortuner Hire in Pimpri Chinchwad"],
  ["Fortuner on Rent for Outstation", "Fortuner Hire for Corporate Office"],
  ["Fortuner on Rent in Pune Monthly", "Fortuner Rent Per Km"],
  ["Fortuner on Rent in Mumbai", "Fortuner on Rent Mumbai"],
  ["Fortuner Car on Rent in Mumbai", "Fortuner Rent in Mumbai"],
  ["Toyota Fortuner on Rent in Velocity Cabs", "Fortuner on Rent in Pune"],
  ["Toyota Fortuner Rental Pune", "Fortuner Cab in Pune"],
  ["Fortuner Car Hire Pune", "Fortuner Taxi Service Pune"],
  ["Book Fortuner Cab Pune", "Fortuner Car Rental Pune"],
  ["Fortuner SUV Rental Pune", "Luxury Fortuner on Rent Pune"],
  ["Cheap Fortuner on Rent Pune", "Fortuner Cab Service Pune"],
  ["Fortuner Outstation Cab Pune", "Fortuner Airport Pickup Pune"],
  ["Fortuner Cab Pune to Mumbai", ""]
],





whychoose: [
  {
    WhyChooseheading: "Luxury Fortuner on Rent in Pune",
    WhyChoosedescription: "Trustline Travels offers premium Toyota Fortuner rental services in Pune with luxury interiors, powerful performance, and professional chauffeur-driven travel for a comfortable experience."
  },
  {
    WhyChooseheading: "Premium SUV for Special Travel",
    WhyChoosedescription: "Toyota Fortuner is perfect for VIP travel, corporate meetings, family trips, airport transfers, weddings, and long-distance journeys with superior comfort and style."
  },
  {
    WhyChooseheading: "Pickup Available Across Pune",
    WhyChoosedescription: "Get Fortuner pickup from Pune Airport, railway station, hotels, offices, Hinjewadi, Baner, Kharadi, Wakad, Pimpri Chinchwad, and other locations."
  },
  {
    WhyChooseheading: "Professional Chauffeur Service",
    WhyChoosedescription: "Our experienced drivers provide safe, punctual, and comfortable travel with excellent knowledge of Pune city and outstation routes."
  },
  {
    WhyChooseheading: "Ideal for Corporate & VIP Transportation",
    WhyChoosedescription: "Hire Fortuner for business executives, client visits, corporate events, premium transfers, and luxury travel requirements."
  },
  {
    WhyChooseheading: "Available for Local & Outstation Trips",
    WhyChoosedescription: "Book Fortuner for Pune local travel, Mumbai trips, Lonavala, Mahabaleshwar, Goa, Nashik, Shirdi, and other destinations."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained SUV",
    WhyChoosedescription: "Our Fortuner vehicles are clean, spacious, and regularly maintained to provide a premium and hassle-free journey."
  },
  {
    WhyChooseheading: "24/7 Fortuner Rental Booking Support",
    WhyChoosedescription: "Reserve Toyota Fortuner on rent anytime in Pune with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Fortuner on Rent in Pune?",
    answer: "Yes, Trustline Travels offers Toyota Fortuner rental services in Pune for luxury travel, corporate requirements, airport transfers, and outstation journeys."
  },
  {
    question: "Can I hire Fortuner with a driver in Pune?",
    answer: "Yes, chauffeur-driven Fortuner rental services are available for safe, comfortable, and premium travel."
  },
  {
    question: "Is Fortuner suitable for corporate and VIP travel?",
    answer: "Yes, Toyota Fortuner is an ideal choice for corporate executives, VIP guests, business meetings, and premium transportation."
  },
  {
    question: "Where can I get Fortuner pickup in Pune?",
    answer: "Pickup is available from Pune Airport, railway station, hotels, offices, residential areas, and major locations across Pune."
  },
  {
    question: "Can I book Fortuner for outstation trips from Pune?",
    answer: "Yes, Fortuner rental is available for Mumbai, Goa, Lonavala, Mahabaleshwar, Nashik, Shirdi, and other outstation destinations."
  },
  {
    question: "Is Toyota Fortuner available for airport transfers?",
    answer: "Yes, Fortuner is available for Pune Airport pickup, drop, and premium airport transportation services."
  },
  {
    question: "What rental options are available for Fortuner?",
    answer: "You can hire Fortuner for hourly rental, daily packages, one-way trips, round trips, and customized travel plans."
  },
  {
    question: "Are toll and parking charges included in Fortuner rental fare?",
    answer: "Toll charges, parking fees, driver allowance, and applicable taxes are generally charged separately unless included in the confirmed quotation."
  },
  {
    question: "Can I book Fortuner for wedding and special events in Pune?",
    answer: "Yes, Fortuner rental is suitable for weddings, special occasions, luxury events, and guest transportation."
  },
  {
    question: "How can I book Fortuner On Rent in Pune with Trustline Travels?",
    answer: "Share your pickup location, destination, travel date, duration, passenger details, and requirements to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Sharma",
    feedback: "We booked Fortuner on rent in Pune for a corporate visit. The SUV was luxurious, clean, and the chauffeur provided excellent service throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback: "Trustline Travels provided a premium Fortuner experience for our family trip. The vehicle was comfortable, the driver was professional, and the entire journey was excellent.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Fortuner On Rent in Pune",
  "image": "https://www.trustlinetravels.com/assets/images/fortuner-on-rent-in-pune.webp",
  "description":
    "Book Fortuner On Rent in Pune with Trustline Travels for premium SUV rental services. We provide Toyota Fortuner rentals for airport transfers, corporate travel, weddings, VIP travel, local sightseeing, outstation trips, one-way, and round-trip journeys with professional chauffeurs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/fortuner-on-rent-in-pune"
  }
};




  return (
    <div>


<Helmet>
  <title>Fortuner On Rent in Pune | Premium SUV Rental | +91 8087080034</title>

  <meta
    name="description"
    content="Book Fortuner On Rent in Pune with Trustline Travels for premium SUV rental services. Hire Toyota Fortuner for airport transfers, corporate travel, weddings, VIP travel, local sightseeing, and outstation trips with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Fortuner on rent pune, Fortuner Rent in Pune, Toyota fortuner on rent in pune, Toyota Fortuner Rental in Pune, Toyota fortuner rental in pune airport, Toyota fortuner rental in pune airport contact number, toyota fortuner hire for corporate travel, Fortuner On Rent in Pune, Fortuner Rental Pune, Toyota Fortuner Cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fortuneronrentinpune;